import React from "react";
import { Spin } from "antd";

const Loader = (props) => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        position: "fixed",
        top: "0",
        left: "0",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        // Must exceed the sticky table header (99, App.css:7362/:7372) and the
        // sidebar (3, DefaultLayout.js:163), and stay below the lowest modal
        // layer (antd .ant-modal-mask, 1000).
        zIndex: "200",
      }}
    >
      <Spin {...props} />
    </div>
  );
};

export default Loader;
